import update from 'immutability-helper';
import moment from 'moment';

class QueueTransformer {
  apiToInternal(task) {
    const changes = {
      queuedAt: {
        $set: task.queuedAt ? moment(task.queuedAt) : null
      },
      startedAt: {
        $set: task.startedAt ? moment(task.startedAt) : null
      },
      finishedAt: {
        $set: task.finishedAt ? moment(task.finishedAt) : null
      }
    };

    return update(task, changes);
  }
}

export default QueueTransformer;
